import type { ListResponse } from 'Services/ProductManagement/types'
import type { LoadingStates } from 'Store'
import { createAsyncThunkWithErrorHandling, getAxiosInstance } from 'Util/ApiClient'
import actionGenerator from 'Util/actionGenerator'
import { createSlice } from '@reduxjs/toolkit'

interface AllowedClient {
  id: string
  allowed: boolean
  client_id: string
  name: string
  default_pta_code: string
  allowed_pta_codes: string[]
  created_timestamp: Date
  modified_timestamp: Date
}

export interface AllowedClientState {
  total_results: number
  next_page: string | null
  previous_page: string | null
  allowedClients: AllowedClient[]
  allAllowedClients: AllowedClient[]
  singleAllowedClient: AllowedClient | null
  loading: LoadingStates
  singleLoading: LoadingStates
  submitLoading: LoadingStates
  allAllowedClientsLoading: LoadingStates
}

const initialState: AllowedClientState = {
  total_results: 0,
  next_page: null,
  previous_page: null,
  allowedClients: [],
  allAllowedClients: [],
  singleAllowedClient: null,
  loading: 'idle',
  singleLoading: 'idle',
  submitLoading: 'idle',
  allAllowedClientsLoading: 'idle'
}

export interface FetchAllowedClientsListParams {
  exclude_manager_client?: boolean
}

const fetchAllAllowedClients = createAsyncThunkWithErrorHandling<
  ListResponse<AllowedClient>,
  FetchAllowedClientsListParams | undefined
>('allowedClient/fetchAllAllowedClients', async data => {
  const { ...params } = data
  const response = await getAxiosInstance().get<ListResponse<AllowedClient>>(
    `/api/v1/allowed-client/`,
    { params }
  )
  return response.data
})
const genericActions = actionGenerator('allowedClient')

const allowedClientSlice = createSlice({
  name: genericActions.name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      /* All allowed clients */
      .addCase(fetchAllAllowedClients.fulfilled, (state, { payload }) => {
        state.allAllowedClients = payload.resources
        state.total_results = payload.total_results
        state.allAllowedClientsLoading = 'fulfilled'
      })
      .addCase(fetchAllAllowedClients.pending, state => {
        state.allAllowedClients = initialState.allowedClients
        state.total_results = initialState.total_results
        state.allAllowedClientsLoading = 'pending'
      })
      .addCase(fetchAllAllowedClients.rejected, state => {
        state.allAllowedClientsLoading = 'rejected'
      })
  }
})

export default allowedClientSlice.reducer

export { fetchAllAllowedClients }
